import {
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE_OPTIONS,
  PAYOFF_PARTICIPATION_OBVS_FREQUENCY,
  PAYOFF_PARTICIPATION_SCHEDULE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_TOUCH_BREAK,
  SUMMARY_PRODUCT_TYPE,
} from './product-capture-field-selectors.consts';

import { FCFieldEffect, FCSelector } from '../../model/form-config.interface';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

const CLEAR_BARRIER_EFFECT: FCFieldEffect = {
  formControlNames: [PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER],
  selectValues: [null],
};

const HIDE_FLOOR_STRIKE_FOR_PRDC_OR_PERFORMANCE_LINKED_COUPON = {
  formControlNames: [SUMMARY_PRODUCT_TYPE],
  options: [
    {
      id: ProductTypeEnum.PERFORMANCE_LINKED_COUPON,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_FLOOR_STRIKE],
          hidden: true,
        },
      ],
    },
    {
      id: ProductTypeEnum.PRDC,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_FLOOR_STRIKE],
          hidden: true,
        },
      ],
    },
  ],
};

export const DOWN_SIDE_TYPE: FCSelector = {
  formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
  options: [
    {
      id: 'NONE',
      label: 'None',
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_STRIKE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE_OPTIONS,
            PAYOFF_PARTICIPATION_FLOOR_STRIKE,
            PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER,
            PAYOFF_PARTICIPATION_OBVS_FREQUENCY,
            PAYOFF_PARTICIPATION_TOUCH_BREAK,
            PAYOFF_PARTICIPATION_SCHEDULE,
          ],
          hidden: true,
        },
        { ...CLEAR_BARRIER_EFFECT },
      ],
    },
    {
      id: 'PUT',
      label: 'Put',
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER,
            PAYOFF_PARTICIPATION_OBVS_FREQUENCY,
            PAYOFF_PARTICIPATION_TOUCH_BREAK,
            PAYOFF_PARTICIPATION_SCHEDULE,
          ],
          hidden: true,
          readOnly: false,
        },
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_STRIKE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE_OPTIONS,
            PAYOFF_PARTICIPATION_FLOOR_STRIKE,
          ],
          hidden: false,
          readOnly: false,
        },
        { ...CLEAR_BARRIER_EFFECT },
      ],
      concatFieldRules: [
        HIDE_FLOOR_STRIKE_FOR_PRDC_OR_PERFORMANCE_LINKED_COUPON,
      ],
    },
    {
      id: 'KNOCK_IN_PUT',
      label: 'Knock-in Put',
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER,
            PAYOFF_PARTICIPATION_OBVS_FREQUENCY,
            PAYOFF_PARTICIPATION_TOUCH_BREAK,
            PAYOFF_PARTICIPATION_STRIKE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE_OPTIONS,
            PAYOFF_PARTICIPATION_FLOOR_STRIKE,
            PAYOFF_PARTICIPATION_SCHEDULE,
          ],
          hidden: false,
          readOnly: false,
        },
      ],
      concatFieldRules: [
        HIDE_FLOOR_STRIKE_FOR_PRDC_OR_PERFORMANCE_LINKED_COUPON,
      ],
    },
    {
      id: '',
      effects: [
        {
          formControlNames: [
            PAYOFF_PARTICIPATION_STRIKE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
            PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE_OPTIONS,
            PAYOFF_PARTICIPATION_FLOOR_STRIKE,
            PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER,
            PAYOFF_PARTICIPATION_OBVS_FREQUENCY,
            PAYOFF_PARTICIPATION_TOUCH_BREAK,
          ],
          hidden: false,
        },
        {
          formControlNames: [PAYOFF_PARTICIPATION_SCHEDULE],
          hidden: true,
        },
        { ...CLEAR_BARRIER_EFFECT },
      ],
    },
  ],
};
